import { CallType } from '@weblite/ts-action/media-proxy'

export enum DownloadFailedSource {
  CHAT = 'chat',
}

export function reportDownloadFailure(
  source: DownloadFailedSource,
  fileType: string,
  timeout: number,
  additionalData?: Record<string, unknown>,
) {
  analite('DOWNLOAD_FAILED', {
    source,
    fileType,
    timeout,
    ...additionalData,
  })
}
